(function (){
    'use strict';

    angular
        .module('services')
        .service('WhoPayService', WhoPayService);

    WhoPayService.$inject = ['$http', 'API_BASE'];

    function WhoPayService ($http, API_BASE) {
        var service = this;

        service.getAll = getAll;


        function getAll () {
            return $http.get(API_BASE + '/who_pay/list');
        }

    }
})();